<template>
<a-spin :spinning="spinning" tip="Loading...">
    <div class="card mb-3">
        <div class="row no-gutters">
            <div class="col-md-12" style="border-right: 1px solid #e0e0e0">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-4">
                            <base-input alternative="" label="From"><br>
                                <a-range-picker v-model="inputDate" :showTime="{ format: 'hh:mm' }" format="MM/DD/YYYY hh:mm A" :placeholder="['Start Time', 'End Time']" style="width:100%"/>
                            </base-input>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-4">
                            <base-input alternative="" label="Select Site">
                                <a-select mode="multiple" v-model="inputSite" showSearch placeholder="All Sites" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" :disabled="site_type != 'ho'">
                                    <a-select-option v-for="option in siteOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                </a-select>
                            </base-input>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-4">
                            <base-input alternative="" label="Select Terminal">
                                <a-select v-model="inputTerminal" showSearch placeholder="All Terminals" optionFilterProp="children" style="width: 100%" :filterOption="filterOption">
                                    <a-select-option v-for="option in terminalOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                </a-select>
                            </base-input>
                        </div>
                    </div>

                    <base-checkbox class="mb-3" v-model="isVatNetSales">
                        Include VAT in Net Sales
                    </base-checkbox>

                    <br>

                     <div class="row">
                        <div class="col-md-4">
                            <base-input alternative="" label="Transaction Type Availability" >
                             <p style="text-indent: 5px; font-size: 11px;">At least one transaction type should be selected (all transaction types selected by default)</p>
                                <a-select mode="multiple" v-model="inputTransType" showSearch placeholder="All Transaction Types" optionFilterProp="children" style="width: 100%" :filterOption="filterOption">
                                    <a-select-option v-for="option in transTypeOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                </a-select>
                            </base-input>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-12">
                            <br>
                            <button class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateReport">Generate Report in PDF</button> &nbsp; &nbsp;
                            <button v-if="JsonData.length < 1" class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateFile">Generate Report</button> &nbsp; &nbsp;
                            <vue-json-to-csv v-if="JsonData.length > 0"  :json-data="JsonData" :csv-title="currentProfile.replace(/_/g, '-')+'-'+currDate.replace(/ /g, '_')">
                                <button id='clickCsvExport' class="btn btn-sm btn-success float-right" style="border-radius: 24px; border:0px; width: 20%;"> Download CSV </button> &nbsp; &nbsp;
                            </vue-json-to-csv>
                            <download-excel v-if="JsonData.length > 0" :data="JsonData" :name="currentProfile.replace(/_/g, '-')+'-'+currDate.replace(/ /g, '')+`.xls`" class="float-right"  style=" width: 20%;">
                                <button class="btn btn-sm btn-success" style="border-radius: 24px; border:0px; width: 100%;" @click.prevent="clearJsonData"> Download excel </button> &nbsp; &nbsp;
                            </download-excel>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</a-spin>
</template>

<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import secureStorage from '../../controllers/secureStorage';
    import moment from 'moment';
    import jsPDF from 'jspdf';
    import 'jspdf-autotable';
    import VueJsonToCsv from 'vue-json-to-csv';
    import reportUtils from '../../components/reportUtils'

    import {
        mapState
    } from 'vuex'

    export default {
        data() {
            return {
                spinning: false,
                inputDate: [moment().startOf('day'), moment().endOf('day')],
                currDate: moment().format("L_LT").split(":").join(";"),
                inputSite: [],
                inputTerminal: 0,
                site_type: "ho",
                siteOptions: [],
                birSalesReports: [],
                JsonData: [],
                isVatNetSales: false,
                terminalOptions: [],
                allTerminals: [],
                inputTransType: [],
                transTypeOptions: []
            }
        },
        watch: {
            inputSite(newSiteIds) {
              this.updateTerminaOptions(newSiteIds)
            },
        },
        mounted: async function () {
            var component_x = this;

            var userId = secureStorage.getItem("userId")
            var sites = await HTTPRequest.getRequest(component_x.endPoint + "sites/get_valid_sites?user_id=" + userId, null);
            component_x.siteOptions = sites;
            component_x.sort(component_x.siteOptions);

            let siteId = secureStorage.getItem("defaultSiteId")
            this.inputSite = [siteId]

            let site = await HTTPRequest.getRequest(this.endPoint + "/sites/" + siteId, null)
            if(site != undefined){
                this.site_type = site.site_type
            }

            var trans_type = await HTTPRequest.getRequest(component_x.endPoint + "pos_transaction_types/get_valid_pos_transaction_types", null)
            component_x.transTypeOptions = trans_type;
            component_x.sort(component_x.transTypeOptions)

            let terminals = await HTTPRequest.getRequest(component_x.endPoint + "terminals/get_valid_terminals?site_id=" + siteId, null);
            component_x.terminalOptions = terminals;
            component_x.terminalOptions.push({id: 0, name: ' All Terminals'})
            component_x.sort(component_x.terminalOptions);
        },
        computed: {
            ...mapState(['currentProfile', 'currentApiURL', 'endPoint', 'parameters']),
        },
        components:{
            VueJsonToCsv
        },
        methods: {
            moment,
            filterOption(input, option) {
                return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            },
            sort(data){
                data.sort(function (a, b) {
                    return a.name.localeCompare(b.name);
                });
            },
            convertToCurrency(num){
                return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
            },
            convertToUpperCase(data){
                let uppercasedData = data.toUpperCase();
                return uppercasedData
            },
            openNotificationWithIcon(type, msg) {
                this.$notification[type]({
                    message: 'Export Error',
                    description: msg 
                });
            },
            isJsonString(str) {
                try {
                    var json = JSON.parse(str);
                    return (typeof json === 'object');
                } catch (e) {
                    return false;
                }
            },
            async updateTerminaOptions(siteId){
                let terminals = await HTTPRequest.getRequest(this.endPoint + "terminals/get_valid_terminals?site_id=" + siteId, null);
                this.terminalOptions = terminals;
                 this.terminalOptions.push({id: 0, name: ' All Terminals'})
                // component_x.sort(component_x.terminalOptions);
                   this.terminalOptions = this.terminalOptions.sort(function (a, b) {
                    return a.name.localeCompare(b.name);
                });
            },
            generateReport: async function () {
                this.spinning= true;
                let from_date = this.inputDate[0].format('YYYY-MM-DD HH:mm:ss');
                let to_date = this.inputDate[1].format('YYYY-MM-DD HH:mm:ss');

                var get_request = await HTTPRequest.getRequest(this.endPoint + 'menu_item_sales?site_id=' + this.inputSite + '&date_from=' + from_date + '&date_to=' + to_date + '&is_vat_on_net_sales=' + this.isVatNetSales + '&trans_type=' + this.inputTransType +  '&terminal_id=' + this.inputTerminal, null);

                if(this.inputDate.length == 0){
                    this.openNotificationWithIcon('error', 'Please make sure to check your current filters.');
                    return
                }

                var siteSpecific = get_request;
                if(siteSpecific.length > 0){
                    let doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'legal' });

                    let reportLogo = document.getElementById('reportLogo');
                    doc.addImage(reportLogo, "PNG", 15, 0, 15, 15);

                     let headers = [];
                     headers = [
                                {content: 'Item Id', styles: {halign: 'center'}},
                                {content: 'Item Name', styles: {halign: 'center'}},
                                {content: 'Transaction Type', styles: {halign: 'center'}},
                                {content: 'Order Qty', styles: {halign: 'center'}},
                                {content: 'Gross Sales', styles: {halign: 'center'}},
                                {content: 'Net Sales', styles: {halign: 'center'}}
                                ]

                    for(var x=0; x < siteSpecific.length; x++){
                         this.birSalesReports = siteSpecific[x].report_details
                          let sub_qty = 0
                            let sub_gross = 0
                            let sub_net = 0
                           
                            let total_qty = 0
                            let total_gross = 0
                            let total_net = 0

                        if(x > 0 && this.birSalesReports.length > 0){
                            doc.addPage();
                        }

                        let reportData = [];
                        let grouper = 'start'
                        let type_header = 'start'

                        doc.setFontSize(14);
                        doc.setFontType("bold");

                        let design_y = 20
                        
                        doc.text(15,design_y,`Menu Item Sales Report`)
                        doc.setFontType("normal");
                        doc.setFontSize(10);

                        design_y = design_y + 5;
                        doc.text(15,design_y,"Date Range: " + this.inputDate[0].format('MMMM DD, YYYY hh:mm A')  + " to " + this.inputDate[1].format('MMMM DD, YYYY hh:mm A'))
                        
                        let terminal = ''
                        if (this.inputTerminal > 0){
                            terminal = siteSpecific[x].report_details[0].terminal_name
                        } else {
                            terminal = 'All Terminals'
                        }
                        design_y = design_y + 5;
                        doc.text(15,design_y,"Store Name: " + siteSpecific[x].report_details[0].site_name)
                        doc.text(15,design_y+5,"Terminal: " + terminal)

                        this.birSalesReports = siteSpecific[x].report_details

                        // let grouper = ''

                        let detailColStyles = {
                            0: {cellWidth: 60},
                            1: {cellWidth: 80},
                            2: {cellWidth: 40},
                            3: {cellWidth: 50},
                            4: {cellWidth: 50},
                            5: {cellWidth: 50},
                        } 
                        
                        // pdf
                        if(this.birSalesReports.length > 0){
                            // let reportData = []
                            // let grouper = 'start'
                            
                           
                            
                            for(let i=0; i < this.birSalesReports.length; i++){
                                let reportLine = this.birSalesReports[i]
                                
                                let grouper_name = reportLine.category.toUpperCase()
                                if (grouper == 'start' || grouper != reportLine.category) {
                                    let detail_header = [{ content: grouper_name, olSpan: 2, styles: { halign: 'left', fontStyle: 'bold' } }];
                                     reportData.push(Object.assign({}, detail_header))
                                }

                                grouper = reportLine.category

                                //body
                                let detail = [
                                    // {content: reportLine.id, styles: {halign: 'left'}},
                                    {content: reportLine.item_id, styles: {halign: 'left'}},
                                    {content: reportLine.item_name, styles: {halign: 'left'}},
                                    {content: reportLine.transaction_type, styles: {halign: 'left'}},
                                    {content: this.convertToCurrency(Number(reportLine.order_qty)), styles: {halign: 'right'}},
                                    {content: this.convertToCurrency(Number(reportLine.gross_sales)), styles: {halign: 'right'}},
                                    {content: this.convertToCurrency(Number(reportLine.net_sales)), styles: {halign: 'right'}},
                                ]
                                
                                    sub_qty += Number(reportLine.order_qty)
                                    sub_gross += Number(reportLine.gross_sales)
                                    sub_net += Number(reportLine.net_sales)
                                    // if (reportLine.category !== 'Thin Crust' && reportLine.category !== 'Hand Tossed'){
                                    if (reportLine.category !== 'THIN CRUST' && reportLine.category !== 'HAND TOSSED'){
                                        total_gross += Number(reportLine.gross_sales)
                                        total_qty += Number(reportLine.order_qty)
                                        total_net += Number(reportLine.net_sales)
                                    }
                                
                                reportData.push(detail)
                                
                                let total_detail = []
                                let site_detail = []
                                let sub_detail = []
                                if(i == this.birSalesReports.length-1){
                                    
                                    sub_detail = [
                                        {content: `Total for: ${grouper_name}`, styles: { halign: 'left'}}, '', '',
                                        {content: this.convertToCurrency(sub_qty), styles: {fontStyle: 'bold'}},
                                        {content: this.convertToCurrency(sub_gross), styles: {fontStyle: 'bold'}},
                                        {content: this.convertToCurrency(sub_net), styles: {fontStyle: 'bold'}}
                                    ]
                                    reportData.push(Object.assign({}, ["rowLine"]))
                                    reportData.push(sub_detail)

                                    total_detail = [
                                        {content: 'Grand Total: ', styles: {fontStyle: 'bold', halign: 'left'}}, '', '', 
                                        {content: this.convertToCurrency(total_qty), styles: {fontStyle: 'bold'}},
                                        {content: this.convertToCurrency(total_gross), styles: {fontStyle: 'bold'}},
                                        {content: this.convertToCurrency(total_net), styles: {fontStyle: 'bold'}}
                                    ]

                                    // site_detail = [
                                    //     {content: `Site Name: ${reportLine.site_name}`, styles: {fontStyle: 'bold', halign: 'left'}}, '', '', '', ''
                                    // ]

                                    reportData.push(Object.assign({}, ["rowLine"]))
                                    reportData.push(total_detail)
                                    reportData.push(site_detail)

                                    //create table
                                    design_y = design_y + 10
                                    doc.autoTable({
                                        startY: design_y, 
                                        head: [headers],
                                        body: reportData, 
                                        theme: 'plain',
                                        tableWidth: 'wrap',
                                        headStyles: {
                                            lineWidth: 0.15
                                        },
                                        styles: {
                                            cellPadding: 1.0, fontSize: 9,
                                            halign: 'right'
                                        },
                                        columnStyles: detailColStyles,
                                        didParseCell: function(data) {
                                            if (data.row.section == 'body' && data.row.raw[0] == 'rowLine'){
                                                data.cell.styles.fillColor = [0, 0, 0]
                                                data.cell.styles.fontSize = 1
                                                data.cell.styles.cellPadding = 0
                                            } else if (data.row.section == 'body' && data.row.raw[6] == 'Total :'){
                                                data.cell.styles.fontStyle = 'bold'
                                            }
                                        }
                                    });
                                } else {
                                    let current_grouper = ""
                                    let next_grouper = ""

                                    current_grouper = reportLine.category
                                    next_grouper = this.birSalesReports[i+1].category

                                    if(current_grouper != next_grouper){
                                        sub_detail = [
                                            {content: `Total for: ${grouper_name}`, styles: { halign: 'left'}}, '', '',
                                            {content: this.convertToCurrency(sub_qty), styles: {fontStyle: 'bold'}},
                                            {content: this.convertToCurrency(sub_gross), styles: {fontStyle: 'bold'}},
                                            {content: this.convertToCurrency(sub_net), styles: {fontStyle: 'bold'}}
                                    ]
                                        reportData.push(Object.assign({}, ["rowLine"]))
                                        reportData.push(sub_detail)
        
                                        total_detail = [ 
                                            {content: 'Grand Total: ', styles: {fontStyle: 'bold', halign: 'left'}}, '', '', 
                                            {content: this.convertToCurrency(total_qty), styles: {fontStyle: 'bold'}},
                                            {content: this.convertToCurrency(total_gross), styles: {fontStyle: 'bold'}},
                                            {content: this.convertToCurrency(total_net), styles: {fontStyle: 'bold'}}
                                    ]

                                        sub_qty = 0
                                        sub_gross = 0
                                        sub_net = 0
                                    }   
                                }
                            }
                        }
                    }

                    let printed_by = secureStorage.getItem("email")
                    if(printed_by == null){
                        printed_by = ''
                    }

                    let pageCount = doc.internal.getNumberOfPages();
                    let footer_x = 340
                    let footer_y = 205
                    for(let i = 1; i <= pageCount; i++) { 
                        doc.setPage(i);
                        // doc.text(480,340,"Page " + doc.internal.getCurrentPageInfo().pageNumber  + " of " + pageCount, "right")
                        reportUtils.pdfTools.addFooter(doc, printed_by, "Menu Item Sales Report", footer_x, footer_y, i, pageCount)
                    }
                    window.open(URL.createObjectURL(doc.output("blob")))
                } else {
                    this.openNotificationWithIcon('warning', 'Please make sure to check your current filters.');
                }
                this.spinning= false;
            },
            generateFile: async function() {
                this.spinning= true;
                let from_date = this.inputDate[0].format('YYYY-MM-DD HH:mm:ss');
                let to_date = this.inputDate[1].format('YYYY-MM-DD HH:mm:ss');
                let from_header = this.inputDate[0].format('YYYY-MM-DD');
                let to_header= this.inputDate[1].format('YYYY-MM-DD');

                var get_request = await HTTPRequest.getRequest(this.endPoint + 'menu_item_sales?site_id=' + this.inputSite + '&date_from=' + from_date + '&date_to=' + to_date + '&is_vat_on_net_sales=' + this.isVatNetSales + '&trans_type=' + this.inputTransType +  '&terminal_id=' + this.inputTerminal, null);

                if(this.inputDate.length == 0){
                    this.openNotificationWithIcon('warning', 'Please make sure to check your current filters.');
                    return
                }

                var siteSpecific = get_request;
                if(siteSpecific.length > 0){
                    let headers = [];
                    let site_specific = [];
                    for(var x=0; x < siteSpecific.length; x++){
                        this.birSalesReports = siteSpecific[x].report_details

                        let grouper = ''

                        headers = ['Item Id','Item Name', 'Transaction Type','Order Qty','Gross Sales','Net Sales']
                        let reportData = []
                        if(this.birSalesReports.length > 0){
                            let grouper = 'start'
                            
                            let sub_qty = 0
                            let sub_gross = 0
                            let sub_net = 0

                            let total_qty = 0
                            let total_gross = 0
                            let total_net = 0

                            for(let i=0; i < this.birSalesReports.length; i++){
                                let reportLine = this.birSalesReports[i]
                                // reportData.push(Object.assign({}, [" "]))
                                let grouper_name = reportLine.category.toUpperCase()
                                if (grouper == 'start' || grouper != reportLine.category) {
                                    let detail_header = [grouper_name];
                                    reportData.push(Object.assign({}, detail_header))
                                }

                                grouper = reportLine.category

                                //body

                                let detail = [
                                    reportLine.item_id,
                                    reportLine.item_name,
                                    reportLine.transaction_type,
                                    this.convertToCurrency(Number(reportLine.order_qty)),
                                    this.convertToCurrency(Number(reportLine.gross_sales)),
                                    this.convertToCurrency(Number(reportLine.net_sales))
                                ]
                                sub_qty += Number(reportLine.order_qty)
                                sub_gross += Number(reportLine.gross_sales)
                                sub_net += Number(reportLine.net_sales)
                                // if (reportLine.category !== 'Thin Crust' && reportLine.category !== 'Hand Tossed'){
                                if (reportLine.category !== 'THIN CRUST' && reportLine.category !== 'HAND TOSSED'){
                                    total_qty += Number(reportLine.order_qty)
                                    total_gross += Number(reportLine.gross_sales)
                                    total_net += Number(reportLine.net_sales)
                                }

                              
                                reportData.push(detail)
                
                                let total_detail = []
                                let site_detail = []
                                let sub_detail = []
                                let terminal_detail = []
                                let terminal = ''
                                if (this.inputTerminal > 0){
                                    terminal = siteSpecific[x].report_details[0].terminal_name
                                } else {
                                    terminal = 'All Terminals'
                                }

                                if(i == this.birSalesReports.length-1){
                                    sub_detail = [`Total for: ${grouper_name}`, '', '', 
                                        this.convertToCurrency(sub_qty),
                                        this.convertToCurrency(sub_gross),
                                        this.convertToCurrency(sub_net)
                                    ]
                                    reportData.push(sub_detail)
                                    reportData.push(Object.assign({}, [" "]))
                                    total_detail = ['Grand Total: ', '', '', 
                                        this.convertToCurrency(total_qty),
                                        this.convertToCurrency(total_gross),
                                        this.convertToCurrency(total_net)
                                    ]
                                    site_detail = [
                                        `Site Name: ${reportLine.site_name} `, '', '', '', ''
                                    ]
                                    terminal_detail = [
                                        `Terminal: ${terminal} `, '', '', '', ''
                                    ]

                                    reportData.push(total_detail)
                                    reportData.push(Object.assign({}, [" "]))
                                    reportData.push(site_detail)
                                    reportData.push(terminal_detail)
                                } else {
                                    let current_grouper = ""
                                    let next_grouper = ""

                                    current_grouper = reportLine.category
                                    next_grouper = this.birSalesReports[i+1].category

                                    if(current_grouper != next_grouper){
                                        sub_detail = [`Total for: ${grouper_name}`, '', '',  
                                            this.convertToCurrency(sub_qty),
                                            this.convertToCurrency(sub_gross),
                                            this.convertToCurrency(sub_net)
                                        ]
                                        reportData.push(sub_detail)
                                        reportData.push(Object.assign({}, [" "]))

                                        sub_qty = 0
                                        sub_gross = 0
                                        sub_net = 0
                                    }   
                                }
                            }
                        }

                        let printed_by = secureStorage.getItem("email")
                        if(printed_by == null){
                            printed_by = ''
                        }

                        // reportData.push([])
                        reportData.push(["Menu Item Sales Report", "Generated By: " + printed_by,"","","","For the Period of " + from_header + " to " + to_header])
                        reportData.push([])

                        let keys = headers;
                        let values = reportData;
                        var values_length = values.length;

                        let newJsonData=[];

                        // change headers and report data as key and value object
                        for(var i=0;i < values_length; i++){
                        	var result =  Object.assign.apply({}, keys.map( (val, index) => ( {
                              		[val]: values[i][index]
                            	  }
                              )
                            )
                          );
                          newJsonData.push(result)
                        }

                        // change undefined on arr
                        newJsonData.forEach(function(obj) {
                          for(var i in obj) {
                            if(obj[i] === undefined || obj[i] === null ) {
                              obj[i] = '';
                            }
                          }
                        });
                        site_specific.push(newJsonData)
                    }
                    this.JsonData = site_specific.flat(Infinity);
                } else {
                    this.openNotificationWithIcon('warning', 'No Data');
                }
                this.spinning= false;
            },
            clearJsonData(){
              this.JsonData = [];
            },
        }
    };
</script>

<style></style>